// extracted by mini-css-extract-plugin
export var green = "points-list-module--green--4UM1q";
export var list = "points-list-module--list--Ql82K";
export var listItem = "points-list-module--list-item--qbW2z";
export var red = "points-list-module--red--gcURg";